<template>
  <button
    type="button"
    class="notification-button"
    :class="{
      'notification-button--unread': count > 0,
      'notification-button--home': variant === 'home',
    }"
    :aria-label="label"
    :aria-expanded="String(expanded)"
    :title="label"
    @click="$emit('click')"
  >
    <md-icon
      class="notification-button__icon"
      md-src="/static/images/icon-mainheader-notification.svg"
      aria-hidden="true"
    />
    <span
      v-if="count > 0"
      class="notification-button__badge"
      aria-hidden="true"
    >{{ count < 100 ? count : '+99' }}</span>
  </button>
</template>

<script>
export default {
  name: 'NotificationButton',
  props: {
    count: {
      type: Number,
      default: 0,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'header',
    },
  },
  computed: {
    label() {
      if (this.count === 1) return 'Informativos: um não visualizado'
      if (this.count > 1) return `Informativos: ${this.count} não visualizados`
      return 'Informativos: nenhum não visualizado'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../static/stylesheets/variables';

.notification-button {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  margin: 0 4px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  color: $label-color;
  cursor: pointer;

  &:hover {
    background: rgba(22, 22, 22, 0.04);
  }

  &:focus-visible {
    outline: 2px solid $theme-primary-color;
    outline-offset: 3px;
  }

  .notification-button__icon.md-icon {
    width: 20px;
    min-width: 20px;
    height: 20px;
    min-height: 20px;
    margin: 0;
    color: inherit;
  }

  &--home {
    border-color: currentColor;
    margin-right: 0;
  }

  &--unread {
    color: $theme-primary-color;

    .notification-button__icon {
      animation: notification-pulse 2.4s ease-in-out infinite;
    }
  }

  &__badge {
    position: absolute;
    top: 1px;
    right: 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    min-width: 16px;
    height: 16px;
    padding: 0 3px;
    border-radius: 8px;
    background: $amaranth;
    color: #fff;
    font-size: 9px;
    font-weight: 700;
    line-height: 1;
  }
}

@keyframes notification-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.55;
  }
}

@media (prefers-reduced-motion: reduce) {
  .notification-button--unread .notification-button__icon {
    animation: none;
  }
}
</style>
